// src/composables/useEnums.js

import { ref, provide, inject } from 'vue'
// import axios from 'axios'
import apiClient from '@/axios'

const enumsSymbol = Symbol()

export function provideEnums() {
  const enums = ref({})

  const fetchEnums = async () => {
    try {
      const response = await apiClient.get('/enums')
      enums.value = response.data
    } catch (error) {
      console.error('Error fetching enums:', error)
    }
  }

  provide(enumsSymbol, enums)
  return { enums, fetchEnums }
}

export function useEnums() {
  const enums = inject(enumsSymbol)
  if (!enums) {
    throw new Error('useEnums must be used within a provideEnums context')
  }
  return enums
}